const COMPONENT_NAME = "Spinner";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}: invalid props`;
var Constant = /* @__PURE__ */ ((Constant2) => {
  Constant2["TextID"] = "loading";
  Constant2["ReducedMotion"] = "(prefers-reduced-motion: reduce)";
  return Constant2;
})(Constant || {});
var SpinnerSize = /* @__PURE__ */ ((SpinnerSize2) => {
  SpinnerSize2["Small"] = "small";
  SpinnerSize2["Medium"] = "medium";
  SpinnerSize2["Large"] = "large";
  return SpinnerSize2;
})(SpinnerSize || {});
const SpinnerSizeMap = {
  small: 16,
  medium: 40,
  large: 88
};
export {
  COMPONENT_NAME,
  Constant,
  INVALID_PROPS_ERROR,
  SpinnerSize,
  SpinnerSizeMap
};
